import React, { useState } from 'react'
import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Chip,
  Divider
} from '@material-ui/core'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import LinkRoundedIcon from '@material-ui/icons/LinkRounded'
import { ReactComponent as AlarmIcon } from 'static/icons/alarm.svg'
import AddActionModal from 'components/AddActionModal'
import AreYouSureModal from 'components/AreYouSureModal'
import { dateStringToJsObj, getDateString, renderLongText, getWeekdayByIndex, generateAndDownloadFile } from 'helpers/dataHelpers'
import history from 'browserHistory'
import useStyles from './styles'


const ActionListItem = (props) => {
  const {
    id,
    // author,
    title,
    iteration,
    recurring,
    deadline,
    text,
    responsible_party,
    handleListItemChange,
    additionalClasses,
    isStatic,
    hideDeadline,
    action_advice,
    showAdvice,
    isMobile
  } = props
  const localClasses = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [showCreateActionDialog, setShowCreateActionDialog] = useState(false)
  const [showAddCalendarDialog, setShowAddCalendarDialog] = useState(false)


  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const handleAddToCalendarClick = (event) => {
    event.stopPropagation()
    const description = `Title: ${text}, Responsible party: ${responsible_party || 'No Responsible Party'}, Added from: Visiaw, url: ${!action_advice ? window.location.href : window.location.origin + '/advices/' + action_advice.id}`
    const date = dateStringToJsObj(deadline)
    const dateArr = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
    const eventData = {
      start: dateArr,
      end: dateArr,
      title: text,
      description: description,
      url: !action_advice ? window.location.href : window.location.origin + '/advices/' + action_advice.id
    }
    if (recurring && iteration) {
      if (iteration === 'YEARLY') {
        eventData.recurrenceRule = `FREQ=${iteration};BYMONTH=${date.getMonth() + 1};BYMONTHDAY=${date.getDate()}`
      } else if (iteration === 'MONTHLY') {
        eventData.recurrenceRule = `FREQ=${iteration};BYMONTHDAY=${date.getDate()};INTERVAL=1`
      } else if (iteration === 'WEEKLY') {
        eventData.recurrenceRule = `FREQ=${iteration};BYDAY=${getWeekdayByIndex(date.getDay())};INTERVAL=1`
      }
    }
    const ics = require('ics')
    ics.createEvent(eventData, (error, value) => {
      if (error) {
        console.log(error)
        return
      }
      setShowAddCalendarDialog(false)
      generateAndDownloadFile('visiaw_event.ics', value)
    })
  }

  // const handleEdit = (event) => {
  //   event.stopPropagation()
  //   setAnchorEl(null)
  //   setShowCreateActionDialog(true)
  // }

  const handleRemoveFromList = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
    handleListItemChange('remove', {id})
  }

  const renderRepeatTitle = (repeatKey) => {
    if (!repeatKey) {
      return 'Never'
    }
    if (repeatKey === 'YEARLY') {
      return 'Yearly'
    } else if (repeatKey === 'MONTHLY') {
      return 'Monthly'
    } else if (repeatKey === 'WEEKLY') {
      return 'Weekly'
    }
    return 'Never'
  }

  const renderAdvice = () => {
    if (!action_advice) {
      return null
    }
    return (
      <Chip
        className={localClasses.chip}
        label={renderLongText(action_advice.title, isMobile ? 12 : null)}
        icon={<LinkRoundedIcon />}
        onClick={() => history.push(`/advices/${action_advice.id}`)}
      />
    )
  }

  return (
    <>
      <div
        id={id}
        className={`${localClasses.action} ${additionalClasses ? additionalClasses : ''}`}
        onClick={isMobile ? () => history.push(`/advices/${action_advice.id}`) : null}
      >
        <div className={localClasses.text}>
          <Typography variant='body2' noWrap className={localClasses.fullWidth}>
            {text}
          </Typography>
        </div>
        {
          showAdvice && !isMobile &&
            <div className={localClasses.advice}>
              {renderAdvice()}
            </div>
        }
        {
          !isMobile &&
            <div className={localClasses.party}>
              <Typography variant='body2' color='textSecondary'>
                {responsible_party ? responsible_party : 'No Responsible Party'}
              </Typography>
            </div>
        }
        {
          !hideDeadline &&
            <div className={localClasses.deadline}>
              <Typography variant='body2' color='textSecondary'>
                {getDateString(dateStringToJsObj(deadline))}
              </Typography>
            </div>
        }
        <div className={localClasses.iteration}>
          <Typography variant='body2' color='textSecondary'>
            {recurring ? renderRepeatTitle(iteration) : 'None'}
          </Typography>
        </div>
        {
          !isStatic ?
            <>
              <div
                className={localClasses.actions}
              >
                <IconButton
                  aria-controls={`action-${id}-menu`}
                  aria-haspopup='true'
                  onClick={handleClick}
                  className={localClasses.formControl}
                >
                  <MoreHorizIcon />
                </IconButton>
                <Menu
                  id={`action-${id}-menu`}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {/*<MenuItem onClick={handleEdit}>Edit</MenuItem>*/}
                  {
                    handleListItemChange ?
                    <MenuItem onClick={handleRemoveFromList}>Remove from list</MenuItem> :
                    null
                  }
                  <MenuItem onClick={handleClose}>Delete</MenuItem>
                </Menu>
              </div>
              {
                showCreateActionDialog && <AddActionModal
                  setShowDialog={setShowCreateActionDialog}
                  showDialog={showCreateActionDialog}
                  actionId={id}
                  getValue={handleListItemChange}
                  actionData={{
                    id,
                    title,
                    iteration,
                    recurring,
                    deadline,
                    text,
                    responsible_party
                  }}
                />
            }
            </> :
            <>
              <div
                className={localClasses.actions}
              >
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation()
                    setShowAddCalendarDialog(true)
                  }}
                  className={localClasses.formControl}
                >
                  <AlarmIcon />
                </IconButton>
              </div>
              {
                showAddCalendarDialog &&
                  <AreYouSureModal
                    setShowDialog={setShowAddCalendarDialog}
                    showDialog={showAddCalendarDialog}
                    actionText='Add to my calendar'
                    action={handleAddToCalendarClick}
                    actionDescription={`Click on "Add to my calendar" button to add "${text}" action to your calendar"`}
                    header='Create calendar event'
                  />
              }
            </>
        }
        

      </div>
      <Divider />
    </>
  )
}

export default ActionListItem
